var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "picture",
    {
      directives: [
        {
          name: "observe-visibility",
          rawName: "v-observe-visibility",
          value: {
            callback: _vm.handleScrollIntoView,
            once: true
          },
          expression:
            "{\n    callback: handleScrollIntoView,\n    once: true\n  }"
        }
      ],
      class: _vm.bemBlock
    },
    [
      _c("img", {
        ref: "img",
        class: [
          _vm.bemElement("img", {
            placeholder: _vm.placeholder && _vm.placeholder.url && !_vm.loaded,
            loading: !_vm.loaded,
            loaded: _vm.loaded
          }),
          _vm.imageClasses
        ],
        attrs: {
          sizes: _vm.sizes,
          src: _vm.shouldLoad ? _vm.src : _vm.placeholderSrc,
          srcset: _vm.shouldLoad && !_vm.error ? _vm.srcset : "",
          "data-placeholder": _vm.placeholderSrc,
          "data-src": _vm.shouldLoad ? "" : _vm.src,
          "data-srcset": _vm.shouldLoad ? "" : _vm.srcset,
          alt: _vm.image.alt,
          loading: _vm.loading,
          title: _vm.useTitle ? _vm.image.title : null,
          itemprop: "image",
          draggable: "false"
        },
        on: {
          error: function($event) {
            $event.preventDefault()
            return _vm.handleImageError($event)
          },
          load: function($event) {
            $event.preventDefault()
            return _vm.handleImageLoad($event)
          },
          click: function($event) {
            return _vm.$emit("image-click", $event)
          }
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }